// extracted by mini-css-extract-plugin
module.exports = {"loadingContainer":"LoadingPage_loadingContainer__4eizy","loader":"LoadingPage_loader__hUqjY","pulsingDots":"LoadingPage_pulsingDots__wR1rx","pulse":"LoadingPage_pulse__zZV_E"};